<template>
  <!-- 订单卡片 -->
  <div class="cardBox" v-for="(item, index) in data" :key="item.id">
    <OrderItem v-if="item._component">
      <!-- 添加新类型 -->
      <component
        :is="item._component"
        :data="item"
        @clickBtn="clickBtn"
        @clickCard="clickCard"
        @clickDelete="clickDelete"
        @refresh="refresh"
        @clickImg="clickImg"
        @viewUseDealer="viewUseDealer"
      />
    </OrderItem>
    <div v-else class="orderItemBox">
      <slot>
        <van-row class="orderHeadRow">
          <slot name="headRow">
            <van-col span="10">
              <span class="creatTime">{{ item.creatTime }}</span>
            </van-col>
            <van-col span="14">
              <p class="statusCol">
                <span class="remind" v-if="item.statusData.showCountDown && item.residueTime > 0">
                  请您在
                  <van-count-down :time="item.residueTime" format="mm:ss" @finish="refresh(index)" />分钟内完成付款
                </span>
                <span v-else>
                  <img v-if="item.statusData.showDeleteIcon" src="../../assets/images/delete-o.png" class="iconImg" @click="clickDelete(item)" />
                  <span>{{ item.statusData.zh }}</span>
                </span>
              </p>
            </van-col>
          </slot>
        </van-row>
        <p class="explain verifyNo" v-if="item.orderTypeFlag === 3">
          {{ `订单编号 : ${item.orderNo || ' 暂无编号'}` }}
        </p>
        <van-row class="orderIfnRow">
          <slot name="ifnRow">
            <!-- 计划信息卡片 -->
            <PlanInfCard
              :data="item.productsData"
              :hiddenPrice="hiddenPrice || item.hiddenPrice"
              @clickCard="clickCard"
              @clickImg="clickImg"
              @clickBtn="clickBtn"
              @viewUseDealer="viewUseDealer"
            ></PlanInfCard>
          </slot>
        </van-row>
        <div class="orderBottomRow">
          <slot name="bottomRow">
            <div v-if="item.orderTypeFlag === 3" class="verifyService">
              <p v-if="item.submitTypeFlag">【{{ item.submitTypeFlag === 2 ? '在线预约' : '到店订单' }}】轮胎快修服务</p>
              <p class="themeColor" v-if="item.submitTypeFlag === 2">【预约时间】{{ item.reserveTime }}</p>
              <van-row>
                <van-col span="20">
                  <p>{{ item.dealer.name || '暂无经销商名称' }}</p>
                </van-col>
                <van-col span="4" style="text-align: right;">
                  <a :href="`tel:${item.dealer.tel}`">
                    <van-icon class="phone" name="phone" />
                  </a>
                </van-col>
              </van-row>
            </div>
            <span class="oabInfo" v-if="item.oabStatus && item?.oabInfo?.status === '10New' && item?.oabInfo?.bookedDate"
              >预约时间: {{ item?.oabInfo?.bookedDate }}</span
            >
            <span class="totalLabel">{{ payAmountLabel(item) }}</span>
            <span class="totalNum">¥{{ item.totalNum }}</span>
            <p class="explain" v-if="item.explain">
              <van-icon size="14" name="question-o" /><span>{{ item.explain }}</span>
            </p>
            <div class="btnBox" v-if="item.btnData.length > 0">
              <BottomBtn :data="item.btnData" @click="clickBtn" align="right" size="small"></BottomBtn>
            </div>
          </slot>
        </div>
      </slot>
    </div>
    <slot name="afterItem"></slot>
  </div>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { useRouter } from 'vue-router'
import PlanInfCard from '@/components/order/PlanInfCard'
import BottomBtn from '@/components/order/BottomBtn'
import OrderItem from '@/components/order/OrderItem'
import ShopCard from '@/components/order/ShopCard'

export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    active: {
      type: [Number, String],
      default: 0
    },
    activeStyle: {
      type: String,
      default: ''
    },
    style: {
      type: String,
      default: ''
    },
    hiddenPrice: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PlanInfCard,
    BottomBtn,
    OrderItem,
    ShopCard
  },
  emits: ['click', 'clickBtn', 'clickDelete', 'refresh', 'hiddenCard', 'viewUseDealer'],
  setup(props, { emit }) {
    const router = useRouter()
    let { data, active, activeStyle, style } = toRefs(props)
    const state = reactive({
      data: data.value,
      active: active.value,
      activeStyle: activeStyle.value,
      style: style.value,
      btnData: []
    })
    const clickCard = v => {
      emit('click', v)
    }
    const clickBtn = v => {
      emit('clickBtn', v)
    }
    const clickDelete = v => {
      emit('clickDelete', v)
    }
    const refresh = () => {
      emit('refresh')
    }
    const clickImg = v => {
      // console.log('clickImg-->', v)
      if (!v.productId) return
      if (v.orderTypeFlag === 1) {
        router.push({
          path: '/planDetail',
          query: {
            loyaltyId: v.productId,
            from: 'orderList',
            event: '查看致友计划详情'
          }
        })
      }
    }
    const hiddenCard = v => {
      // console.log("hiddenCard-->", v);
      emit('hiddenCard', v)
    }
    const payAmountLabel = item => {
      // console.log('payAmountLabel-->', item)
      let awaitArr = ['awaitPayLine', 'awaitPay', 'awaitPayMethod', 'awaitScan', 'alreadyCancel']
      let res = awaitArr.includes(item.statusData.en) ? '应付总额' : '实付金额'
      if (item.payTypeFlag == 3) {
        res = awaitArr.includes(item.statusData.en) ? '应付意向金' : '实付意向金'
        //新增 0元订单 应付意向金修改为实付意向金
        if (item.orderAmount == 0 && res == '应付意向金') {
          res = '实付意向金'
        }
        //新增 接单之前显示实付意向金，接单后是实付总额
        if (item.orderStatusFlag == 6) {
          res = '实付总额'
        }
      }
      if (item.miniMallOrder === 1) {
        res = item.submitTypeFlag === 2 ? '意向金' : '厂商建议零售价'
      }
      return res
    }
    const viewUseDealer = data => {
      emit('viewUseDealer', data)
    }
    return {
      ...toRefs(state),
      clickCard,
      clickBtn,
      clickDelete,
      refresh,
      clickImg,
      hiddenCard,
      payAmountLabel,
      viewUseDealer
    }
  }
}
</script>
<style lang="scss" scoped>
.cardBox {
  padding: 0 10px;
  margin-bottom: 8px;
  background-color: #fff;
  text-align: left;
  font-size: 12px;
  color: #999;
}
.orderHeadRow {
  height: 36px;
  padding: 0 10px;
  line-height: 36px;
  border-bottom: 1px solid #eee;
}
.statusCol {
  text-align: right;
  img {
    width: 14px;
    height: 16px;
    vertical-align: middle;
  }
  span {
    margin-left: 5px;
    vertical-align: middle;
  }
}
.remind {
  color: #c30000;
  .van-count-down {
    display: inline-block;
    color: #c30000;
  }
}
.orderIfnRow {
  padding: 15px 10px 18px;
}
.imgBox,
.imgBox img {
  width: 100%;
  height: 45px;
}
.orderIfnBox {
  padding-left: 8px;
}
.planName {
  font-size: 13px;
  margin-bottom: 8px;
  color: #333;
  // font-weight: 700;
}
.dealerPhoneBox {
  width: 40px;
  height: 50px;
  padding-left: 10px;
  text-align: center;
}
.planNameBox {
  width: calc(100% - 40px);
}
.dealerNameBox {
  margin-bottom: 8px;
}
.priceBox {
  text-align: right;
}
.orderBottomRow {
  padding: 18px 10px;
  border-top: 1px solid #eee;
  text-align: right;
}
.bookedDate {
  margin-right: 10px;
  font-size: 13px;
  color: #666;
}
.totalLabel {
  color: #111;
  font-size: 14px;
  font-weight: 600;
  opacity: 0.8;
}
.totalNum {
  margin: 0 20px 8px;
  font-size: 14px;
  color: #3088c5;
  font-weight: 600;
}
.explain {
  padding: 12px 20px 1px;
  color: #999;
  text-align: center;
  .van-icon {
    margin-right: 8px;
    vertical-align: middle;
  }
  span {
    vertical-align: middle;
  }
}
.verifyNo {
  padding-left: 12px;
  color: #666;
  text-align: left;
}
.btnBox {
  margin-top: 18px;
}
.handleBtn {
  display: inline-block;
  width: 88px;
  height: 32px;
  margin: 16px 8px 0;
  line-height: 32px;
  text-align: center;
  border: solid 1px #eee;
}
.fullBtn {
  background-color: #3088c5;
  color: #fff;
  border: solid 1px transparent;
}
.phone {
  font-size: 24px;
  color: #3088c5;
  transform: rotate(-90deg);
}
.verifyService {
  text-align: left;
  p {
    margin-bottom: 12px;
  }
}
.oabInfo {
  margin-right: 5px;
}
</style>
